'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSetupWelcome = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bluetooth = require('constants/bluetooth');

var _bluetooth2 = _interopRequireDefault(_bluetooth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prefer-stateless-function */
var DeviceSetupWelcome = exports.DeviceSetupWelcome = function DeviceSetupWelcome(_ref) {
  var updateDevice = _ref.updateDevice;
  return _react2.default.createElement(
    'div',
    { className: 'modal__device-setup__welcome' },
    _react2.default.createElement(
      'div',
      { className: 'modal__device-setup__top' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'device.welcome-header',
        defaultMessage: 'Welcome to ClassPass Live!',
        tagName: 'h3'
      }),
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'device.welcome-intro',
        defaultMessage: 'Let\u2019s get your profile and equipment set up \u2013 it should only take a few minutes.',
        tagName: 'p'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal__device-setup__content' },
      _react2.default.createElement('img', { src: require('../../../static/img/device-setup-welcome.svg'), alt: 'Welcome', className: 'modal__device-setup__welcome-img m+' }),
      _react2.default.createElement(
        'button',
        {
          className: 'bt bt--primary bt--width-md mv',
          onClick: function onClick() {
            return updateDevice({ status: _bluetooth2.default.INPUT_INFO });
          },
          key: 'device.welcome.button'
        },
        'Setup your profile'
      )
    )
  );
};

DeviceSetupWelcome.propTypes = {
  updateDevice: _propTypes2.default.func
};